import { defineMessages } from "react-intl";

const messages = defineMessages({
  addButton: {
    id: "recordPane.noteList.addButton",
    defaultMessage: "Add",
    description: "Title of a button to add a note to a company",
  },
  noData: {
    id: "recordPane.noteList.noData",
    defaultMessage: "Add a note to populate this list",
    description: "Text of the 'No Data' state in Notes section in a Edit pane",
  },
  noNotesFound: {
    id: "recordPane.noteList.noNotesFound",
    defaultMessage: "No notes found.",
    description: "No notes found on search",
  },
  title: {
    id: "recordPane.noteList.title",
    defaultMessage: "Notes {count}",
    description: "Title of a Notes section on a record pane",
  },
  uneditable: {
    id: "recordPane.noteList.addButton.uneditable",
    defaultMessage:
      "You do not have permission to use this feature. Please contact your admin to request a change.",
    description: "Tooltip for an Add note Button when user has no edit rights",
  },
  unreadable: {
    id: "recordPane.noteList.unreadable",
    defaultMessage: "Notes are hidden",
    description: "Text of the 'PHI-hidden' state in Notes section in a Edit pane",
  },
});

export default messages;
